import {
  GET_PRICES,
  GET_PRICES_SUCCESS,
  GET_PRICES_FAILURE,
  GET_PICKUP_POINTS,
  GET_PICKUP_POINTS_SUCCESS,
  GET_PICKUP_POINTS_FAILURE,
  SET_SELECTED_OFFER,
  SET_PICKUP_POINT
} from './addCommandActions';

const initialState = {
  prices: [],
  pickupPoints: [],
  selectedOffer: null,
  pricesLoading: true,
  pickupPointLoading: true,
  selectedPickupPoint: {}
};

const addCommandReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PRICES:
      return {
        ...state,
        pricesLoading: true
      };
    case GET_PRICES_SUCCESS:
      return {
        ...state,
        prices: action.payload.prices,
        selectedOffer: action.payload.prices.length
          ? action.payload.prices[0]
          : null,
        pricesLoading: false
      };
    case GET_PRICES_FAILURE:
      return {
        ...state,
        pricesLoading: false
      };
    case GET_PICKUP_POINTS:
      return {
        ...state,
        pickupPointLoading: true
      };
    case GET_PICKUP_POINTS_SUCCESS:
      return {
        ...state,
        pickupPoints: action.payload.pickupPoints,
        pickupPointLoading: false
      };
    case GET_PICKUP_POINTS_FAILURE:
      return {
        ...state,
        pickupPointLoading: false
      };
    case SET_SELECTED_OFFER:
      return {
        ...state,
        selectedOffer: action.payload
      };
    case SET_PICKUP_POINT:
      return {
        ...state,
        selectedPickupPoint: action.payload
      };
    default:
      return state;
  }
};

export default addCommandReducer;
